import {
  InstantAnswerBuilderFn,
  InstantAnswerContext,
  InstantAnswerScenario,
} from "@faire/help-center-self-serve/types";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

export const DidNotGetInsiderFreeDutiesIA: InstantAnswerBuilderFn = (
  strictLocalize
) => ({
  titleBuilder: (context) => {
    return getAnswer(context, strictLocalize).getTitle();
  },

  descriptionBuilder: (context) => {
    return getAnswer(context, strictLocalize).getDescription();
  },
});

const getAnswer = (
  _context: InstantAnswerContext,
  strictLocalize: StrictLocalizeFunction
): InstantAnswerScenario => {
  return {
    getTitle: () => WHY_I_DID_NOT_RECEIVE_FREE_DUTIES(strictLocalize),
    getDescription: () => [
      INSIDER_OFFERS_FREE_DUTIES_WITH_SELECT_BRANDS(strictLocalize),
    ],
  };
};

const WHY_I_DID_NOT_RECEIVE_FREE_DUTIES = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage: "Why didn’t I receive free duties on my order?",
    description: {
      text: "Title for the answer of Free duties issue",
    },
  });

const INSIDER_OFFERS_FREE_DUTIES_WITH_SELECT_BRANDS = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage:
      "It’s important to note that your Insider membership offers free duties with select brands. While this benefit isn’t applicable across the entire marketplace, you can easily identify eligible brands while browsing on Faire. Just look for brands marked with “Insider Free Shipping & duties” along with a blue key symbol. Additionally, if your Insider membership covers duties for a particular brand, it will be indicated at checkout.",
  });
